module.exports = __webpack_public_path__ + "bca08f6159274aa990d5b487a43c0703.pdf";